const SIDEBAR_COOKIE_NAME = 'sidebar_state'

/**
 * Reads the sidebar's persisted open/collapsed state from `document.cookie`.
 * Synchronous so the shell can pass it as `defaultOpen` on first render,
 * avoiding an expanded -> collapsed flash on reload.
 */
export function readSidebarCookie(): boolean {
  const match = document.cookie.match(new RegExp(`(?:^|; )${SIDEBAR_COOKIE_NAME}=([^;]*)`))
  return match ? match[1] === 'true' : true
}
